// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".topTitle[data-v-98c81bb2]{width:1200px;margin:0 auto;width:1400px;padding:40px 0;color:#222}.topTitle h1[data-v-98c81bb2]{font-size:36px}", ""]);
// Exports
module.exports = exports;
